/** Branch-scoped dashboard URL helpers for branch_admin users. */

export function branchDashboardPath(branch) {
  if (!branch?.code) return '/';
  return `/b/${encodeURIComponent(branch.code)}`;
}

export function resolveBranchFromCode(branches, code) {
  if (!code || !Array.isArray(branches)) return null;
  const decoded = decodeURIComponent(code);
  return branches.find((b) => b.code === decoded) || null;
}

export function isBranchDashboardPath(pathname) {
  return /^\/b\/[^/]+$/.test(pathname || '');
}

export function extractBranchCodeFromPath(pathname) {
  const m = (pathname || '').match(/^\/b\/([^/]+)$/);
  return m ? decodeURIComponent(m[1]) : null;
}

export function resolveBranchAdminHomePath(user) {
  const branches = Array.isArray(user?.managed_branches) ? user.managed_branches : [];
  if (branches.length === 1) return branchDashboardPath(branches[0]);
  if (branches.length > 1) return '/branch-select';
  return '/branch-select';
}